import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

export const accountStatusService = {
    getStatus: async () : Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getAccountStatus);        
    }    
}